import { locationActions  } from '../actions';
import { actions as countriesActions } from '../../../../../actions/common/countries';


export default function locations ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case locationActions.SET_LOCATIONS: return generalLocationsReducer( newState, action );
        case countriesActions.SET_COUNTRIES: return generalLocationsReducer( newState, action );
        case locationActions.GENERAL_LOCATION_SUCCESS: return generalLocationsReducer( newState, action );
        default: return newState;
    }
}

function generalLocationsReducer ( newState, action ) {
    delete action.type;
    return  Object.assign( newState, { ...action } );;
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/locations.js